import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  updateFromList,
  updatePastOrderList,
} from "redux/actions";

import "./sidebar.scss";
import ProductsFilters from "../ProductsFilters";
import FilterSlidebar from '../FilterSlidebar';

const SidebarTheme2 = ({
  isMobileSidebar,
  isShowReorder,
}) => {
  const dispatch = useDispatch();

  const [isShowReorderCheckbox, setShowReorderCheckbox] = useState(true);

  const {
    pastOrderCheckedList,
    fromCheckedList,
  } = useSelector(({ product }) => product);

  const {
    from_list = [],
    from_list_title = "",
    from_post_orders_title = "",
    from_post_orders_list = [],
  } = useSelector(
    ({ product }) => product.filterOptionList.reorder_section || {}
  );

  const handleFromListChange = (fromList) => {
    dispatch(updateFromList(fromList));
  };

  const handleFromPastOrderChange = (pastDate) => {
    dispatch(updatePastOrderList(pastDate));
  };

  return (
    <>
      <ProductsFilters />
      <FilterSlidebar />
      <div
        className={`listing-sidebar-sticky-theme2 ${
          isMobileSidebar ? "mobile-view" : ""
        }`}
        id="style-5"
      >
        <div className="listing-page-sidebar-theme2">
          {isShowReorder ? (
            <div className="sidebar-item-list">
              <div
                className="sidebar-title-alignment re-order-checkbox-wrapper"
                onClick={() => setShowReorderCheckbox(!isShowReorderCheckbox)}
              >
                <span>Re-Order</span>
                <i className="fa-solid fa-angle-down"></i>
              </div>
              <div
                className={
                  isShowReorderCheckbox ? "dropdown-show" : " dropdown-hidden "
                }
              >
                <div>
                  <span className="reorder-dropdown-subheading">
                    {from_list_title}
                  </span>
                  {from_list && !!from_list.length
                    ? from_list
                        .filter((item) => item.is_visible === "1")
                        .map((fromList) => {
                          return (
                            <div
                              className="ift-item-with-checkbox"
                              key={fromList.list_id}
                            >
                              <input
                                type="checkbox"
                                id={fromList.list_id}
                                onChange={() =>
                                  handleFromListChange(fromList.list_id)
                                }
                                checked={fromCheckedList.includes(
                                  fromList.list_id
                                )}
                              />
                              <label htmlFor={fromList.list_id}>
                                <span>{fromList.title} 1</span>
                              </label>
                            </div>
                          );
                        })
                    : "No list found."}
                </div>
                <div>
                  <span className="reorder-dropdown-subheading">
                    {from_post_orders_title}
                  </span>

                  {from_post_orders_list && !!from_post_orders_list.length
                    ? from_post_orders_list
                        .filter((item) => item.is_visible === "1")
                        .map((pastOrderDate) => {
                          return (
                            <div
                              className="ift-item-with-checkbox"
                              key={pastOrderDate.list_id}
                            >
                              <input
                                type="checkbox"
                                id={pastOrderDate.reorder_date}
                                onChange={() =>
                                  handleFromPastOrderChange(
                                    pastOrderDate.reorder_date
                                  )
                                }
                                checked={pastOrderCheckedList.includes(
                                  pastOrderDate.reorder_date
                                )}
                              />
                              <label htmlFor={pastOrderDate.reorder_date}>
                                <span>{pastOrderDate.title}</span>
                              </label>
                            </div>
                          );
                        })
                    : "No orders found."}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default SidebarTheme2;
